export const SETTING_REVENUE_COLUMN = 'SETTING_REVENUE_COLUMN';
export const SETTING_REVENUE_INDEX = 'SETTING_REVENUE_INDEX';
export const SETTING_REVENUE_LOADING_INDEX = 'SETTING_REVENUE_LOADING_INDEX';
export const SETTING_REVENUE_LOADING_SHOW = 'SETTING_REVENUE_LOADING_SHOW';
export const SETTING_REVENUE_STATEMENT = 'SETTING_REVENUE_STATEMENT';
export const SETTING_REVENUE_RESET = 'SETTING_REVENUE_RESET';
export const SETTING_REVENUE_SEARCH = 'SETTING_REVENUE_SEARCH';
export const SETTING_REVENUE_SHOW = 'SETTING_REVENUE_SHOW';
